export enum FactorCategory {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    // UPDRS
    NORMAL = 'NORMAL',
    SLIGHT = 'SLIGHT',
    MILD = 'MILD',
    MODERATE = 'MODERATE',
    SEVERE = 'SEVERE',
    // CRST
    MARKED = 'MARKED',
    NONE = 'NONE',
}
